"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoCall/PreCall.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);





var _videoRoom = require('web/selectors/videoRoom');








var _videoCall = require('web/selectors/videoCall');
var _videoCall3 = require('web/services/videoCall');
var _hooks = require('web/services/hooks');

var _VideoCall = require('web/components/VideoCall');
var _RoomHeader = require('web/components/VideoCall/RoomHeader'); var _RoomHeader2 = _interopRequireDefault(_RoomHeader);
var _Modals = require('web/components/VideoCall/Modals');
var _useClassState = require('./useClassState');














// Was a class inside connect(): memo keeps connect's props bail-out. The
// StreamManager is an instance value (a ref); state keeps class setState
// semantics (every update re-renders).
const PreCallScreen = ({
  gotoCallSetup, gotoCall,
  onRoomLinkCopy,
  openMobileMoreOptionsModal,
}) => {
  const roomName = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomName)
  const roomLink = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomLink)
  const currentCamDeviceId = _hooks.useAppSelector.call(void 0, _videoCall.selectCurrentCamDeviceId)
  const isCamOn = _hooks.useAppSelector.call(void 0, _videoCall.selectIsCamOn)
  const isMicOn = _hooks.useAppSelector.call(void 0, _videoCall.selectIsMicOn)
  const areMicIssuesPresent = _hooks.useAppSelector.call(void 0, _videoCall.selectAreMicIssuesPresent)
  const areCamIssuesPresent = _hooks.useAppSelector.call(void 0, _videoCall.selectAreCamIssuesPresent)
  const isCamCycleAvailable = _hooks.useAppSelector.call(void 0, _videoCall.selectIsCamCycleAvailable)
  const anonymousUserName = _hooks.useAppSelector.call(void 0, _videoRoom.selectAnonymousUserName)
  const currentRoomUserKey = _hooks.useAppSelector.call(void 0, state => {
    const roomUser = _videoRoom.selectCurrentVideoRoomUser.call(void 0, state)
    return roomUser ? roomUser.RoomUserKey : null
  })
  // Not rendered, but connect() subscribed to them, so a change re-renders the
  // screen as before.
  _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomKey)
  _hooks.useAppSelector.call(void 0, _videoCall.selectCurrentMicDeviceId)

  const [state, setState] = _useClassState.useClassState({
    preCallStream: null,
    isNamePromptModalOpen: false,
  })
  const streamManager = _react.useRef(null)

  const openNamePromptModal = _react.useCallback.call(void 0, () => setState({ isNamePromptModalOpen: true }), [setState])
  const closeNamePromptModal = _react.useCallback.call(void 0, () => setState({ isNamePromptModalOpen: false }), [setState])

  // componentDidMount (first run) / componentDidUpdate (the cam device or
  // the cam toggle changed).
  _react.useLayoutEffect.call(void 0, () => {
    const updateStream = (s) => setState({ preCallStream: s })

    if (!streamManager.current) {
      streamManager.current = new (0, _videoCall3.StreamManager)({
        camDeviceId: currentCamDeviceId,
        useCam: true,
      })

      streamManager.current
        .update({ isCamOn })
        .then(updateStream)
        .catch(() => updateStream(null))
      return
    }

    // `useCam` is not an update() option; it is passed (and ignored) as before.
    const updateOptions = {
      isCamOn,
      camDeviceId: currentCamDeviceId,
      useCam: true,
    }
    streamManager.current.update(updateOptions)
      .then(updateStream)
      .catch(() => updateStream(null))
  }, [currentCamDeviceId, isCamOn, setState])

  // componentWillUnmount
  _react.useLayoutEffect.call(void 0, () => () => { _optionalChain([streamManager, 'access', _ => _.current, 'optionalAccess', _2 => _2.stop, 'call', _3 => _3()]) }, [])

  const handleUserNameChange = (userName) => {
    closeNamePromptModal()
    _actions2.default.updateAnonymousUser({ userName })
    _actions2.default.updateVideoRoomUserName({
      // SAFETY: the JS sent the key as is, null when there is no room user yet.
      RoomUserKey: currentRoomUserKey ,
      RoomUserName: userName,
    })
  }

  const { preCallStream, isNamePromptModalOpen } = state

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_RoomHeader2.default, {
        roomName: roomName,
        roomLink: roomLink,
        onRoomLinkCopy: onRoomLinkCopy,
        openMobileMoreOptionsModal: openMobileMoreOptionsModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}
      )
      , _react2.default.createElement(_VideoCall.PreCall, {
        userName: anonymousUserName,
        currentRoomUserKey: currentRoomUserKey,
        openNamePromptModal: openNamePromptModal,
        isMicOn: isMicOn,
        isCamOn: isCamOn,
        isCamCycleAvailable: isCamCycleAvailable,
        onCycleCam: _actions2.default.cycleCam,
        onToggleMic: _actions2.default.toggleMic,
        onToggleCam: _actions2.default.toggleCam,
        gotoCall: gotoCall,
        gotoCallSetup: gotoCallSetup,
        localStream: preCallStream,
        areMicIssuesPresent: areMicIssuesPresent,
        areCamIssuesPresent: areCamIssuesPresent, __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}
      )
      , _react2.default.createElement(_Modals.NamePromptModal, {
        isOpen: isNamePromptModalOpen,
        userName: anonymousUserName,
        onProceed: handleUserNameChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, PreCallScreen)
